import { get } from 'lodash-es'

export function getPhotos(state, props) {
  return state.data.photos
}

export function getDefaultPhoto(state, props) {
  return getPhotos(state, props).default
}

export function getPhoto(state, props) {
  const { photoId } = props
  const idString = photoId ? photoId.toString() : null
  if (!idString) return null

  const allPhotos = getPhotos(state, props)
  const photo = get(allPhotos, idString) || null
  return photo
}
